export default function Header() {

    return (

        <div className="header">

            <h4>Dashboard</h4>

            <div>

                Welcome,
                <strong> Admin</strong>

            </div>

        </div>

    );

}